export const compareLabels = (a: { label: string }, b: { label: string }) =>
  a.label.toLowerCase().localeCompare(b.label.toLowerCase());
